export enum QuestionType {
	Option = 1,
	Date = 2,
	Time = 3,
	DateTime = 4,
	Text = 5,
	Number = 6,
	File = 7,
	Boolean = 8,
}
